<template>
  <vue-editor ref="editor" v-model="editorContent" useCustomImageHandler @text-change="handleTextChange" @image-added="handleImageAdded"> </vue-editor>
</template>

<script>
export default {
  props: {
    dataInfo: {
      default: "",
    },
  },
  data() {
    return {
      editorContent: null,
    };
  },
  methods: {
    handleTextChange() {
      this.$emit("onchange", this.editorContent);
    },
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      let formData = new FormData();
      formData.append("file", file);
      this.$store
        .dispatch("upload/UploadFile", formData)
        .then((result) => {
          let { fileUrl } = result;
          Editor.insertEmbed(cursorLocation, "image", fileUrl);
          resetUploader();
        })
        .catch(() => {});
    },
  },
  watch: {
    dataInfo: {
      handler(data) {
        this.editorContent = data;
      },
      immediate: true,
    },
  },
};
</script>
